import {ShaderMaterial, Vector2} from "three";
import sharpenVertex from "features/apartmentViewer/ApartmentViewer/shaders/sharpenMaterial/sharpenVertex.glsl";
import sharpenFragment from "features/apartmentViewer/ApartmentViewer/shaders/sharpenMaterial/sharpenFragment.glsl";

export class SharpenMaterialFactory {
    public static createMaterial() : ShaderMaterial {
        return new ShaderMaterial({
            uniforms: {
                tDiffuse: {
                    value: null
                },
                amount: {
                    value: .6
                },
                resolution: {
                    value: new Vector2(),
                }
            },
            vertexShader: sharpenVertex,
            fragmentShader: sharpenFragment,
        })
    }
}
